export default __webpack_public_path__ + "static/media/img1.5038420f.jpg";